import styled from '@emotion/styled';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';
import {
  Button,
  Card,
  Icon,
  SearchField,
  Spacing,
  StyledDiv,
  StyledFixedButtonWrapper,
  Typography,
} from '@taleemabad/dsm/components';
import { Select, SelectOption } from '../../../../../atoms/select/select';

export interface SchoolAssignment {
  id: number;
  name: string;
  coachName?: string;
  emis?: string;
  region?: string; // Added for filtering in stories
}

export interface RmAssignSchoolsProps {
  schools: SchoolAssignment[];
  onSave: () => void;
  searchValue: string;
  onSearchChange: (val: string) => void;
  onSchoolClick: (school: SchoolAssignment) => void;
  regionOptions: SelectOption[];
  selectedRegion: string;
  onRegionChange: (option: SelectOption) => void;
}

export const RmAssignSchools = ({
  schools,
  onSave,
  searchValue,
  onSearchChange,
  onSchoolClick,
  regionOptions,
  selectedRegion,
  onRegionChange,
}: RmAssignSchoolsProps) => {
  return (
    <StyledDiv
      flexDirection="column"
      width="100%"
      padding="0 0 var(--rk-spacing-xxxxxxxl) 0"
      gap={12}
    >
      <StyledSearchFieldWrapper>
        <SearchField
          variant="outlined"
          value={searchValue}
          onChange={onSearchChange}
          label="Search School"
        />
      </StyledSearchFieldWrapper>

      <Spacing marginBottom="xs" />

      <Select
        label="Region"
        options={regionOptions}
        defaultValue={selectedRegion}
        onChange={onRegionChange}
        width="200px"
        variant="outlined"
      />

      <Typography variant="textTitleMedium" textAlign="left">
        Assign schools to coaches
      </Typography>
      <StyledCardsContainer>
        {schools.length === 0 ? (
          <Typography variant="textBodyMedium" textAlign="center">
            No schools available.
          </Typography>
        ) : (
          schools.map((school, idx) => (
            <Card
              variant="outline"
              width="100%"
              key={school.id + idx}
              minHeight="60px"
              onClick={() => onSchoolClick(school)}
            >
              <StyledDiv justifyContent="space-between" alignItem="center">
                <Typography variant="textLabelLarge">
                  EMIS: {school.emis || 'N/A'}
                </Typography>
                <Icon name="chevron_right" cursor="pointer" />
              </StyledDiv>
              <Typography variant="textTitleMedium">{school.name}</Typography>
              <Typography variant="textBodyMediumOnSurfaceVariant">
                {school?.coachName
                  ? `Coaches Assigned: ${school?.coachName}`
                  : 'No coaches assigned'}
              </Typography>
            </Card>
          ))
        )}
      </StyledCardsContainer>
      <StyledFixedButtonWrapper>
        <Button onClick={onSave}>Save Schedule</Button>
      </StyledFixedButtonWrapper>
    </StyledDiv>
  );
};

const StyledCardsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--rk-spacing-md);

  ${mq(BreakpointSizes.desktop)} {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
`;

const StyledSearchFieldWrapper = styled.div`
  width: 100%;
  ${mq(BreakpointSizes.desktop)} {
    width: 50%;
  }
`;
